export const getRootUrl = () => window.location.hostname.includes('hubspot') ? '/connect-public' : '';